import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
export function FanExperience() {
  const {
    t
  } = useLanguage();
  return <section className="relative py-24 md:py-32 overflow-hidden" data-id="element-20">
      {/* Background Image */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-scroll" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1518605368461-1e1e111e1b6a?auto=format&fit=crop&q=40&w=800")'
    }} data-id="element-21">
        <div className="absolute inset-0 bg-usa-navy/80 mix-blend-multiply" data-id="element-22"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-usa-black via-usa-black/60 to-transparent" data-id="element-23"></div>
      </div>
      <div className="container relative z-10 mx-auto px-6 md:px-12 text-center" data-id="element-24">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-4xl mx-auto" data-id="element-25">
          <span className="text-usa-silver font-oswald uppercase tracking-widest text-sm font-bold mb-4 block" data-id="element-26">
            {t('fan.label')}
          </span>
          <h2 className="text-4xl md:text-7xl font-oswald font-bold uppercase leading-tight mb-8 drop-shadow-2xl" data-id="element-27">
            {t('fan.title1')} <br className="hidden md:block" data-id="element-28" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400" data-id="element-29">
              {t('fan.title2')}
            </span>
          </h2>
          <p className="text-base md:text-xl text-gray-200 mb-10 font-light max-w-2xl mx-auto" data-id="element-30">
            {t('fan.desc')}
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4" data-id="element-31">
            <a href="https://www.instagram.com/usmnt/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-white/10 border border-white/20 hover:bg-gradient-to-r hover:from-[#f09433] hover:via-[#dc2743] hover:to-[#bc1888] hover:border-transparent hover:text-white text-white px-8 py-4 rounded-full font-oswald uppercase tracking-wider font-bold transition-all duration-300 min-h-[44px] active:scale-95" data-id="element-32">
              Instagram
            </a>
            <a href="https://facebook.com/officialussoccer" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-white/10 border border-white/20 hover:bg-white hover:text-usa-navy text-white px-8 py-4 rounded-full font-oswald uppercase tracking-wider font-bold transition-all duration-300 min-h-[44px]" data-id="element-33">
              Facebook
            </a>
            <a href="https://x.com/USMNT" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-white/10 border border-white/20 hover:bg-white hover:text-usa-navy text-white px-8 py-4 rounded-full font-oswald uppercase tracking-wider font-bold transition-all duration-300 min-h-[44px]" data-id="element-34">
              X
            </a>
            <a href="https://www.tiktok.com/@ussoccer" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-white/10 border border-white/20 hover:bg-white hover:text-usa-navy text-white px-8 py-4 rounded-full font-oswald uppercase tracking-wider font-bold transition-all duration-300 min-h-[44px]" data-id="element-35">
              TikTok
            </a>
            <a href="https://www.youtube.com/@ussoccer" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-white/10 border border-white/20 hover:bg-white hover:text-usa-navy text-white px-8 py-4 rounded-full font-oswald uppercase tracking-wider font-bold transition-all duration-300 min-h-[44px]" data-id="element-36">
              YouTube
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}